import { ActionTree } from 'vuex'
import { Reports } from './types'
import { RootState } from '../types'

export const actions: ActionTree<Reports, RootState> = {

    setReports({ state, commit }, payload) {
        state.reports = [];
        if (payload.length > 0) {
            payload.forEach(report => {
                commit('setReport', report)
            })
        }
        commit('resetFilterReportsState')
    },
    filterReportsByString({ state, dispatch, commit }, { string }) {
        if (string.length > 1) {
          const filterReports = state.reports.filter(
            report => {
                const entities = JSON.parse(report.entidades);
                const reportName = report.nombre_informe.split('|')[0]
                const r = reportName.toLowerCase().match(string) 
                    || entities.find( r => r.domain?.toLowerCase().match(string) || r.label?.toLowerCase().match(string))
                return r;
            }
          )
          commit('setFilterReportsByString', { filterReports })
        } else commit('resetFilterReportsState')
    },
    setCurrentReport({ commit }, report) {
        commit('setCurrentReport', report)
    },
    toogleGraphView({ commit }) {
        commit('toogleGraphView')
      },
    enableGraphView({ commit }) {
        commit('enableGraphView')
    },
    disableGraphView({ commit }) {
        commit('disableGraphView')
    },
    setOndemand({commit}, value) {
        commit('setOndemand', value)
    },
    cleanReportsState({ commit }) {
        commit('cleanReportsState')
    }
}